import { BrandMark } from "../components/BrandMark";

// Rendered when the tenant/user flag resolver says web access is off for this guard. Honest and
// calm — this is policy steering ("your team uses the phone app"), not an error. Reuses the boot
// screen's styling so it inherits brand + dark theme without new CSS.

export function WebAccessBlocked({
  accountName,
  onSignOut,
}: {
  accountName: string;
  onSignOut: () => void;
}) {
  return (
    <div className="boot">
      <main className="boot__card" role="main" aria-labelledby="blocked-title">
        <BrandMark className="boot__mark" />
        <p className="boot__eyebrow">SecOps</p>
        <h1 id="blocked-title" className="boot__title">
          Guard Web
        </h1>
        <p className="boot__tagline">Web access is turned off for {accountName}.</p>
        <p className="boot__detail">
          Your team uses the SecOps Guard app for patrols. Open the app on your phone, or contact
          your supervisor if you think this is a mistake.
        </p>
        <button className="shell__signout" type="button" onClick={onSignOut}>
          Sign out
        </button>
      </main>
    </div>
  );
}
